<template>
  <svg
    width="36"
    height="24"
    viewBox="0 0 36 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_16368_355562)">
      <rect x="0.5" y="0.5" width="35" height="23" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="35" height="23" rx="3.5" stroke="#CCCFD7" />
      <path
        d="M22.1396 5.29999C25.6642 5.30009 28.5215 8.29994 28.5215 12.0002C28.5214 15.7003 25.6641 18.7003 22.1396 18.7004C20.5595 18.7004 19.1146 18.0956 18 17.0969C16.8854 18.0956 15.4406 18.7004 13.8604 18.7004C10.3358 18.7004 7.47862 15.7004 7.47852 12.0002C7.47852 8.29988 10.3358 5.29999 13.8604 5.29999C15.4404 5.29999 16.8855 5.90393 18 6.90253C19.1145 5.90398 20.5596 5.29999 22.1396 5.29999Z"
        fill="#ED0006"
      />
      <path
        d="M22.1396 5.29999C25.6642 5.30004 28.5215 8.29991 28.5215 12.0002C28.5214 15.7004 25.6641 18.7003 22.1396 18.7004C20.5594 18.7004 19.1146 18.0956 18 17.0969C19.3714 15.868 20.2421 14.0414 20.2422 12.0002C20.2422 9.95872 19.3716 8.13142 18 6.90253C19.1145 5.90395 20.5596 5.29999 22.1396 5.29999Z"
        fill="#F9A000"
      />
      <path
        d="M18 6.90247C19.3716 8.13136 20.2422 9.95865 20.2422 12.0001C20.2421 14.0414 19.3714 15.8679 18 17.0968C16.6286 15.8679 15.7579 14.0413 15.7578 12.0001C15.7578 9.95868 16.6284 8.13136 18 6.90247Z"
        fill="#FF5E00"
      />
    </g>
    <defs>
      <clipPath id="clip0_16368_355562">
        <rect width="36" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
